import React from "react";
import { IS_B2C } from "../../config/api.config";

import { useSelector } from "react-redux";

const ContactUs = ({ section }) => {
  const support = useSelector((state) => state.support);
  const promotions = useSelector((state) => state.promotions.socials);

  if (section == "Sidebar") {
    //Right Sidebar & Left Sidebar
    return (
      <div className="p-1">
        <div className="flex flex-col gap-1 p-3 items-center  rounded">
          {(promotions?.Whatsapp?.is_active ||
            promotions?.Instagram ||
            promotions?.Telegram ||
            promotions?.Facebook ||
            promotions?.Gmail) && (
            <span className="text-text_color_primary1 font-semibold">
              Contact Us
            </span>
          )}
          <div className="flex w-full items-center justify-center gap-1 ">
            {promotions?.Whatsapp?.is_active && (
              <a
                title="whatsapp"
                href={promotions?.Whatsapp?.url}
                target="_blank"
                className="flex items-center justify-center rounded-md bg-bg_color_icon w-[45px] h-[45px] md:w-20 md:h-20"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  className="w-[24px] h-[24px] md:w-12 md:h-12 max-w-full max-h-full"
                >
                  <g clipPath="url(#clip0_140_22030)">
                    <path
                      d="M12.003 0H11.997C5.3805 0 0 5.382 0 12C0 14.625 0.846 17.058 2.2845 19.0335L0.789 23.4915L5.4015 22.017C7.299 23.274 9.5625 24 12.003 24C18.6195 24 24 18.6165 24 12C24 5.3835 18.6195 0 12.003 0ZM18.9855 16.9455C18.696 17.763 17.547 18.441 16.6305 18.639C16.0035 18.7725 15.1845 18.879 12.4275 17.736C8.901 16.275 6.63 12.6915 6.453 12.459C6.2835 12.2265 5.028 10.5615 5.028 8.8395C5.028 7.1175 5.9025 6.279 6.255 5.919C6.5445 5.6235 7.023 5.4885 7.482 5.4885C7.6305 5.4885 7.764 5.496 7.884 5.502C8.2365 5.517 8.4135 5.538 8.646 6.0945C8.9355 6.792 9.6405 8.514 9.7245 8.691C9.81 8.868 9.8955 9.108 9.7755 9.3405C9.663 9.5805 9.564 9.687 9.387 9.891C9.21 10.095 9.042 10.251 8.865 10.47C8.703 10.6605 8.52 10.8645 8.724 11.217C8.928 11.562 9.633 12.7125 10.671 13.6365C12.0105 14.829 13.0965 15.21 13.485 15.372C13.7745 15.492 14.1195 15.4635 14.331 15.2385C14.5995 14.949 14.931 14.469 15.2685 13.9965C15.5085 13.6575 15.8115 13.6155 16.1295 13.7355C16.4535 13.848 18.168 14.6955 18.5205 14.871C18.873 15.048 19.1055 15.132 19.191 15.2805C19.275 15.429 19.275 16.1265 18.9855 16.9455Z"
                      fill="var(--icon-color-brand-secondary)"
                    ></path>
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear_140_22030"
                      x1="-2.24"
                      y1="-7.70251e-08"
                      x2="28.5351"
                      y2="2.61163"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#6e081c"></stop>
                      <stop
                        offset="1"
                        stopColor="var(--icon-color-brand-secondary)"
                      ></stop>
                    </linearGradient>
                    <clipPath id="clip0_140_22030">
                      <rect width="24" height="24" fill="white"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </a>
            )}
            {promotions?.Instagram?.is_active && (
              <a
                title="Instagram"
                href={promotions?.Instagram?.url}
                target="_blank"
                className="flex items-center justify-center rounded-md bg-bg_color_icon w-[45px] h-[45px] md:w-20 md:h-20"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  brandcolor="var(--icon-color-brand-secondary)"
                  brandcolor2="var(--icon-color-brand-tertiary)"
                  className="w-[24px] h-[24px] md:w-12 md:h-12 max-w-full max-h-full"
                >
                  <g clipPath="url(#clip0_140_22052)">
                    <path
                      d="M16.8503 0H7.14973C3.20735 0 0 3.20735 0 7.14973V16.8503C0 20.7926 3.20735 24 7.14973 24H16.8503C20.7926 24 24 20.7926 24 16.8503V7.14973C24 3.20735 20.7926 0 16.8503 0ZM21.5856 16.8503C21.5856 19.4655 19.4655 21.5856 16.8503 21.5856H7.14973C4.5345 21.5856 2.4144 19.4655 2.4144 16.8503V7.14973C2.4144 4.53446 4.5345 2.4144 7.14973 2.4144H16.8503C19.4655 2.4144 21.5856 4.53446 21.5856 7.14973V16.8503Z"
                      fill="var(--icon-color-brand-secondary)"
                    ></path>
                    <path
                      d="M12 5.79272C8.57731 5.79272 5.79275 8.57729 5.79275 11.9999C5.79275 15.4226 8.57731 18.2072 12 18.2072C15.4227 18.2072 18.2073 15.4226 18.2073 11.9999C18.2073 8.57725 15.4227 5.79272 12 5.79272ZM12 15.7928C9.90525 15.7928 8.20715 14.0947 8.20715 12C8.20715 9.90523 9.90529 8.20712 12 8.20712C14.0948 8.20712 15.7929 9.90523 15.7929 12C15.7929 14.0947 14.0947 15.7928 12 15.7928Z"
                      fill="var(--icon-color-brand-secondary)"
                    ></path>
                    <path
                      d="M18.2193 7.32682C19.0407 7.32682 19.7067 6.6609 19.7067 5.83944C19.7067 5.01798 19.0407 4.35205 18.2193 4.35205C17.3978 4.35205 16.7319 5.01798 16.7319 5.83944C16.7319 6.6609 17.3978 7.32682 18.2193 7.32682Z"
                      fill="url(#paint2_linear_140_22052)"
                    ></path>
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear_140_22052"
                      x1="-2.24"
                      y1="-7.70251e-08"
                      x2="28.5351"
                      y2="2.61163"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#6e081c"></stop>
                      <stop
                        offset="1"
                        stopColor="var(--icon-color-brand-secondary)"
                      ></stop>
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_140_22052"
                      x1="4.63406"
                      y1="5.79272"
                      x2="20.5531"
                      y2="7.14365"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#6e081c"></stop>
                      <stop
                        offset="1"
                        stopColor="var(--icon-color-brand-secondary)"
                      ></stop>
                    </linearGradient>
                    <linearGradient
                      id="paint2_linear_140_22052"
                      x1="16.4542"
                      y1="4.35205"
                      x2="20.2688"
                      y2="4.67576"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#6e081c"></stop>
                      <stop
                        offset="1"
                        stopColor="var(--icon-color-brand-secondary)"
                      ></stop>
                    </linearGradient>
                    <clipPath id="clip0_140_22052">
                      <rect width="24" height="24" fill="white"></rect>
                    </clipPath>
                  </defs>
                </svg>
              </a>
            )}
            {promotions?.Telegram?.is_active && (
              <a
                title="Telegram"
                href={promotions?.Telegram?.url}
                target="_blank"
                className="flex items-center justify-center rounded-md bg-bg_color_icon w-[45px] h-[45px] md:w-20 md:h-20"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  brandcolor="var(--icon-color-brand-secondary)"
                  brandcolor2="var(--icon-color-brand-tertiary)"
                  className="w-[24px] h-[24px] md:w-12 md:h-12 max-w-full max-h-full"
                >
                  <g clipPath="url(#clip0_140_22026)">
                    <path
                      d="M9.917 15.1809L9.52 20.7649C10.088 20.7649 10.334 20.5209 10.629 20.2279L13.292 17.6829L18.81 21.7239C19.822 22.2879 20.535 21.9909 20.808 20.7929L24.43 3.82092L24.431 3.81992C24.752 2.32392 23.89 1.73892 22.904 2.10592L1.61399 10.2569C0.160995 10.8209 0.182995 11.6309 1.36699 11.9979L6.81 13.6909L19.453 5.77992C20.048 5.38592 20.589 5.60392 20.144 5.99792L9.917 15.1809Z"
                      fill="var(--icon-color-brand-secondary)"
                    ></path>
                  </g>
                  <defs>
                    <linearGradient
                      id="paint0_linear_140_22026"
                      x1="-1.74013"
                      y1="1.99951"
                      x2="28.9377"
                      y2="5.12347"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#6e081c"></stop>
                      <stop
                        offset="1"
                        stopColor="var(--icon-color-brand-secondary)"
                      ></stop>
                    </linearGradient>
                    <clipPath id="clip0_140_22026">
                      <rect
                        width="24"
                        height="24"
                        fill="white"
                        transform="translate(0.5)"
                      ></rect>
                    </clipPath>
                  </defs>
                </svg>
              </a>
            )}
            {promotions?.Facebook?.is_active && (
              <a
                title="Facebook"
                href={promotions?.Facebook?.url}
                target="_blank"
                className="flex items-center justify-center rounded-md bg-bg_color_icon w-[45px] h-[45px] md:w-20 md:h-20"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  brandcolor="var(--icon-color-brand-secondary)"
                  brandcolor2="var(--icon-color-brand-tertiary)"
                  className="w-[24px] h-[24px] md:w-12 md:h-12 max-w-full max-h-full"
                >
                  <path
                    d="M24 12.0301C24 5.38948 18.624 0 12 0C5.376 0 0 5.38948 0 12.0301C0 17.8526 4.128 22.7008 9.6 23.8195V15.6391H7.2V12.0301H9.6V9.02256C9.6 6.70075 11.484 4.81203 13.8 4.81203H16.8V8.42105H14.4C13.74 8.42105 13.2 8.96241 13.2 9.62406V12.0301H16.8V15.6391H13.2V24C19.26 23.3985 24 18.2737 24 12.0301Z"
                    fill="url(#paint0_linear_140_22057)"
                  ></path>
                  <defs>
                    <linearGradient
                      id="paint0_linear_140_22057"
                      x1="-2.24"
                      y1="0"
                      x2="28.5351"
                      y2="2.61158"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#6e081c"></stop>
                      <stop
                        offset="1"
                        stopColor="var(--icon-color-brand-secondary)"
                      ></stop>
                    </linearGradient>
                  </defs>
                </svg>
              </a>
            )}
            {promotions?.Gmail?.is_active && (
              <a
                title="Gmail"
                href={promotions?.Gmail?.url}
                target="_blank"
                className="flex items-center justify-center rounded-md bg-bg_color_icon w-[45px] h-[45px] md:w-20 md:h-20"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  brandcolor="var(--icon-color-brand-secondary)"
                  brandcolor2="var(--icon-color-brand-tertiary)"
                  className="w-[24px] h-[24px] md:w-12 md:h-12 max-w-full max-h-full"
                >
                  <path
                    d="M15.3474 12.1105L22.2632 16.4842V7.54736L15.3474 12.1105Z"
                    fill="var(--icon-color-brand-secondary)"
                  ></path>
                  <path
                    d="M1.73684 7.54736V16.4842L8.65263 12.1105L1.73684 7.54736Z"
                    fill="var(--icon-color-brand-secondary)"
                  ></path>
                  <path
                    d="M20.9842 4.94214H3.01579C2.38421 4.94214 1.86315 5.41582 1.76842 6.03161L12 12.7737L22.2316 6.03161C22.1368 5.41582 21.6 4.94214 20.9842 4.94214Z"
                    fill="var(--icon-color-brand-secondary)"
                  ></path>
                  <path
                    d="M14.1632 12.8843L12.3474 14.0843C12.2368 14.1474 12.1263 14.1948 12 14.1948C11.8737 14.1948 11.7474 14.1632 11.6526 14.0843L9.83684 12.8843L1.78421 17.9843C1.87895 18.6001 2.4 19.058 3.03158 19.0738H21C21.6316 19.0738 22.1526 18.6159 22.2474 17.9843L14.1632 12.8843Z"
                    fill="var(--icon-color-brand-secondary)"
                  ></path>
                  <defs>
                    <linearGradient
                      id="paint0_linear_140_22036"
                      x1="14.7019"
                      y1="7.54736"
                      x2="23.5955"
                      y2="8.13141"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#6e081c"></stop>
                      <stop
                        offset="1"
                        stopColor="var(--icon-color-brand-secondary)"
                      ></stop>
                    </linearGradient>
                    <linearGradient
                      id="paint1_linear_140_22036"
                      x1="1.09137"
                      y1="7.54736"
                      x2="9.98495"
                      y2="8.13141"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#6e081c"></stop>
                      <stop
                        offset="1"
                        stopColor="var(--icon-color-brand-secondary)"
                      ></stop>
                    </linearGradient>
                    <linearGradient
                      id="paint2_linear_140_22036"
                      x1="-0.141477"
                      y1="4.94214"
                      x2="25.0488"
                      y2="10.5277"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#6e081c"></stop>
                      <stop
                        offset="1"
                        stopColor="var(--icon-color-brand-secondary)"
                      ></stop>
                    </linearGradient>
                    <linearGradient
                      id="paint3_linear_140_22036"
                      x1="-0.125684"
                      y1="12.8843"
                      x2="24.3745"
                      y2="19.7581"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#6e081c"></stop>
                      <stop
                        offset="1"
                        stopColor="var(--icon-color-brand-secondary)"
                      ></stop>
                    </linearGradient>
                  </defs>
                </svg>
              </a>
            )}
          </div>
        </div>
      </div>
    );
  }

  //Footer
  return (
    <div className="grid w-full grid-cols-12 lg:grid-cols-9 p-6">
      <div className="col-span-8 lg:col-span-5">
        <h2 className="text-text_Ternary text-start text-lg md:text-xl font-bold relative w-max">
          <span>Quick Links</span>
          <span className="absolute bottom-0 origin-left popUpOpenAnimation left-0 w-[75%] h-0.5  bg-bg_text_brand_primary rounded-full"></span>
        </h2>
        <div className="w-full grid grid-cols-1 xxs:grid-cols-2 md:grid-cols-3 gap-3 py-2">
          <a
            className="group relative text-sm md:text-base  transition-all duration-300  active:text-[#6e081d] hover:text-[#6e081d] relative h-max w-max whitespace-pre max-w-full col-span-1 text-text_color_primary1"
            title="Responsible Gambling"
            href="/responsible-gambling"
          >
            <span className="tw-text-nowrap">Responsible Gambling</span>
            <span className="absolute bottom-0 left-0 w-[100%] h-0.5 bg-bg_text_brand_primary rounded-full origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></span>
          </a>
          <a
            className="group relative text-sm md:text-base  transition-all duration-300  active:text-[#6e081d] hover:text-[#6e081d] relative h-max w-max whitespace-pre max-w-full col-span-1 text-text_color_primary1"
            title="Privacy Policy"
            href="/privacy-policy"
          >
            <span className="tw-text-nowrap">Privacy Policy</span>
            <span className="absolute bottom-0 left-0 w-[100%] h-0.5 bg-bg_text_brand_primary rounded-full origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></span>
          </a>
          <a
            className="group relative text-sm md:text-base  transition-all duration-300  active:text-[#6e081d] hover:text-[#6e081d] relative h-max w-max whitespace-pre max-w-full col-span-1 text-text_color_primary1"
            title="Exclusion Policy"
            href="/exclusion-policy"
          >
            <span className="tw-text-nowrap">Exclusion Policy</span>
            <span className="absolute bottom-0 left-0 w-[100%] h-0.5 bg-bg_text_brand_primary rounded-full origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></span>
          </a>
          <a
            className="group relative text-sm md:text-base  transition-all duration-300  active:text-[#6e081d] hover:text-[#6e081d] relative h-max w-max whitespace-pre max-w-full col-span-1 text-text_color_primary1"
            title="Rules &amp; Regulations"
            href="/rules-regulations"
          >
            <span className="tw-text-nowrap">Rules &amp; Regulations</span>
            <span className="absolute bottom-0 left-0 w-[100%] h-0.5 bg-bg_text_brand_primary rounded-full origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></span>
          </a>
        </div>
      </div>
      {IS_B2C && (
        <div className="col-span-4 flex flex-col gap-y-2">
          {(promotions?.Whatsapp?.is_active ||
            promotions?.Instagram ||
            promotions?.Telegram ||
            promotions?.Facebook ||
            promotions?.Gmail) && (
            <h3 className="hidden md:block text-text_color_primary1 font-normal text-start text-lg md:text-xl font-bold  w-full">
              Connect with us
            </h3>
          )}
          <div className="w-full flex justify-center items-center md:items-start md:justify-start gap-2 lg:gap-2.5">
            {promotions?.Telegram && (
              <div className="flex items-center justify-center overflow-hidden rounded-md">
                <a
                  title={promotions?.Telegram?.url}
                  href={promotions?.Telegram?.url}
                  target="_blank"
                  className="flex  items-center justify-center rounded-md bg-bg_color_icon size-[45px] md:size-[50px] hover:scale-[110%] transition-all duration-300 hover:shadow-lg hover:opacity-90"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    className="w-6 h-6 md:w-[28px] md:h-[28px]"
                  >
                    <g clipPath="url(#clip0_140_22026)">
                      <path
                        d="M9.917 15.1809L9.52 20.7649C10.088 20.7649 10.334 20.5209 10.629 20.2279L13.292 17.6829L18.81 21.7239C19.822 22.2879 20.535 21.9909 20.808 20.7929L24.43 3.82092L24.431 3.81992C24.752 2.32392 23.89 1.73892 22.904 2.10592L1.61399 10.2569C0.160995 10.8209 0.182995 11.6309 1.36699 11.9979L6.81 13.6909L19.453 5.77992C20.048 5.38592 20.589 5.60392 20.144 5.99792L9.917 15.1809Z"
                        fill="var(--icon-color-brand-secondary)"
                      ></path>
                    </g>
                    <defs>
                      <linearGradient
                        id="paint0_linear_140_22026"
                        x1="-1.74013"
                        y1="1.99951"
                        x2="28.9377"
                        y2="5.12347"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#6e081c"></stop>
                        <stop
                          offset="1"
                          stopColor="var(--icon-color-brand-secondary)"
                        ></stop>
                      </linearGradient>
                      <clipPath id="clip0_140_22026">
                        <rect
                          width="24"
                          height="24"
                          fill="white"
                          transform="translate(0.5)"
                        ></rect>
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </div>
            )}
            {promotions?.Whatsapp?.is_active && (
              <div className="flex items-center justify-center overflow-hidden rounded-md">
                <a
                  title={promotions?.Whatsapp?.url}
                  href={promotions?.Whatsapp?.url}
                  target="_blank"
                  className="flex  items-center justify-center rounded-md bg-bg_color_icon size-[45px] md:size-[50px] hover:scale-[110%] transition-all duration-300 hover:shadow-lg hover:opacity-90"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    className="w-6 h-6 md:w-[28px] md:h-[28px]"
                  >
                    <g clipPath="url(#clip0_140_22030)">
                      <path
                        d="M12.003 0H11.997C5.3805 0 0 5.382 0 12C0 14.625 0.846 17.058 2.2845 19.0335L0.789 23.4915L5.4015 22.017C7.299 23.274 9.5625 24 12.003 24C18.6195 24 24 18.6165 24 12C24 5.3835 18.6195 0 12.003 0ZM18.9855 16.9455C18.696 17.763 17.547 18.441 16.6305 18.639C16.0035 18.7725 15.1845 18.879 12.4275 17.736C8.901 16.275 6.63 12.6915 6.453 12.459C6.2835 12.2265 5.028 10.5615 5.028 8.8395C5.028 7.1175 5.9025 6.279 6.255 5.919C6.5445 5.6235 7.023 5.4885 7.482 5.4885C7.6305 5.4885 7.764 5.496 7.884 5.502C8.2365 5.517 8.4135 5.538 8.646 6.0945C8.9355 6.792 9.6405 8.514 9.7245 8.691C9.81 8.868 9.8955 9.108 9.7755 9.3405C9.663 9.5805 9.564 9.687 9.387 9.891C9.21 10.095 9.042 10.251 8.865 10.47C8.703 10.6605 8.52 10.8645 8.724 11.217C8.928 11.562 9.633 12.7125 10.671 13.6365C12.0105 14.829 13.0965 15.21 13.485 15.372C13.7745 15.492 14.1195 15.4635 14.331 15.2385C14.5995 14.949 14.931 14.469 15.2685 13.9965C15.5085 13.6575 15.8115 13.6155 16.1295 13.7355C16.4535 13.848 18.168 14.6955 18.5205 14.871C18.873 15.048 19.1055 15.132 19.191 15.2805C19.275 15.429 19.275 16.1265 18.9855 16.9455Z"
                        fill="var(--icon-color-brand-secondary)"
                      ></path>
                    </g>
                    <defs>
                      <linearGradient
                        id="paint0_linear_140_22030"
                        x1="-2.24"
                        y1="-7.70251e-08"
                        x2="28.5351"
                        y2="2.61163"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#6e081c"></stop>
                        <stop
                          offset="1"
                          stopColor="var(--icon-color-brand-secondary)"
                        ></stop>
                      </linearGradient>
                      <clipPath id="clip0_140_22030">
                        <rect width="24" height="24" fill="white"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </div>
            )}
            {promotions?.Gmail && (
              <div className="flex items-center justify-center overflow-hidden rounded-md">
                <a
                  title={promotions?.Gmail?.url}
                  href={promotions?.Gmail?.url}
                  target="_blank"
                  className="flex  items-center justify-center rounded-md bg-bg_color_icon size-[45px] md:size-[50px] hover:scale-[110%] transition-all duration-300 hover:shadow-lg hover:opacity-90"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    className="w-6 h-6 md:w-[28px] md:h-[28px]"
                  >
                    <path
                      d="M15.3474 12.1105L22.2632 16.4842V7.54736L15.3474 12.1105Z"
                      fill="var(--icon-color-brand-secondary)"
                    ></path>
                    <path
                      d="M1.73684 7.54736V16.4842L8.65263 12.1105L1.73684 7.54736Z"
                      fill="var(--icon-color-brand-secondary)"
                    ></path>
                    <path
                      d="M20.9842 4.94214H3.01579C2.38421 4.94214 1.86315 5.41582 1.76842 6.03161L12 12.7737L22.2316 6.03161C22.1368 5.41582 21.6 4.94214 20.9842 4.94214Z"
                      fill="var(--icon-color-brand-secondary)"
                    ></path>
                    <path
                      d="M14.1632 12.8843L12.3474 14.0843C12.2368 14.1474 12.1263 14.1948 12 14.1948C11.8737 14.1948 11.7474 14.1632 11.6526 14.0843L9.83684 12.8843L1.78421 17.9843C1.87895 18.6001 2.4 19.058 3.03158 19.0738H21C21.6316 19.0738 22.1526 18.6159 22.2474 17.9843L14.1632 12.8843Z"
                      fill="var(--icon-color-brand-secondary)"
                    ></path>
                    <defs>
                      <linearGradient
                        id="paint0_linear_140_22036"
                        x1="14.7019"
                        y1="7.54736"
                        x2="23.5955"
                        y2="8.13141"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#6e081c"></stop>
                        <stop
                          offset="1"
                          stopColor="var(--icon-color-brand-secondary)"
                        ></stop>
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear_140_22036"
                        x1="1.09137"
                        y1="7.54736"
                        x2="9.98495"
                        y2="8.13141"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#6e081c"></stop>
                        <stop
                          offset="1"
                          stopColor="var(--icon-color-brand-secondary)"
                        ></stop>
                      </linearGradient>
                      <linearGradient
                        id="paint2_linear_140_22036"
                        x1="-0.141477"
                        y1="4.94214"
                        x2="25.0488"
                        y2="10.5277"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#6e081c"></stop>
                        <stop
                          offset="1"
                          stopColor="var(--icon-color-brand-secondary)"
                        ></stop>
                      </linearGradient>
                      <linearGradient
                        id="paint3_linear_140_22036"
                        x1="-0.125684"
                        y1="12.8843"
                        x2="24.3745"
                        y2="19.7581"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#6e081c"></stop>
                        <stop
                          offset="1"
                          stopColor="var(--icon-color-brand-secondary)"
                        ></stop>
                      </linearGradient>
                    </defs>
                  </svg>
                </a>
              </div>
            )}
            {promotions?.Instagram && (
              <div className="flex items-center justify-center overflow-hidden rounded-md">
                <a
                  title={promotions?.Instagram?.url}
                  href={promotions?.Instagram?.url}
                  target="_blank"
                  className="flex  items-center justify-center rounded-md bg-bg_color_icon size-[45px] md:size-[50px] hover:scale-[110%] transition-all duration-300 hover:shadow-lg hover:opacity-90"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    className="w-6 h-6 md:w-[28px] md:h-[28px]"
                  >
                    <g clipPath="url(#clip0_140_22052)">
                      <path
                        d="M16.8503 0H7.14973C3.20735 0 0 3.20735 0 7.14973V16.8503C0 20.7926 3.20735 24 7.14973 24H16.8503C20.7926 24 24 20.7926 24 16.8503V7.14973C24 3.20735 20.7926 0 16.8503 0ZM21.5856 16.8503C21.5856 19.4655 19.4655 21.5856 16.8503 21.5856H7.14973C4.5345 21.5856 2.4144 19.4655 2.4144 16.8503V7.14973C2.4144 4.53446 4.5345 2.4144 7.14973 2.4144H16.8503C19.4655 2.4144 21.5856 4.53446 21.5856 7.14973V16.8503Z"
                        fill="var(--icon-color-brand-secondary)"
                      ></path>
                      <path
                        d="M12 5.79272C8.57731 5.79272 5.79275 8.57729 5.79275 11.9999C5.79275 15.4226 8.57731 18.2072 12 18.2072C15.4227 18.2072 18.2073 15.4226 18.2073 11.9999C18.2073 8.57725 15.4227 5.79272 12 5.79272ZM12 15.7928C9.90525 15.7928 8.20715 14.0947 8.20715 12C8.20715 9.90523 9.90529 8.20712 12 8.20712C14.0948 8.20712 15.7929 9.90523 15.7929 12C15.7929 14.0947 14.0947 15.7928 12 15.7928Z"
                        fill="var(--icon-color-brand-secondary)"
                      ></path>
                      <path
                        d="M18.2193 7.32682C19.0407 7.32682 19.7067 6.6609 19.7067 5.83944C19.7067 5.01798 19.0407 4.35205 18.2193 4.35205C17.3978 4.35205 16.7319 5.01798 16.7319 5.83944C16.7319 6.6609 17.3978 7.32682 18.2193 7.32682Z"
                        fill="url(#paint2_linear_140_22052)"
                      ></path>
                    </g>
                    <defs>
                      <linearGradient
                        id="paint0_linear_140_22052"
                        x1="-2.24"
                        y1="-7.70251e-08"
                        x2="28.5351"
                        y2="2.61163"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#6e081c"></stop>
                        <stop
                          offset="1"
                          stopColor="var(--icon-color-brand-secondary)"
                        ></stop>
                      </linearGradient>
                      <linearGradient
                        id="paint1_linear_140_22052"
                        x1="4.63406"
                        y1="5.79272"
                        x2="20.5531"
                        y2="7.14365"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#6e081c"></stop>
                        <stop
                          offset="1"
                          stopColor="var(--icon-color-brand-secondary)"
                        ></stop>
                      </linearGradient>
                      <linearGradient
                        id="paint2_linear_140_22052"
                        x1="16.4542"
                        y1="4.35205"
                        x2="20.2688"
                        y2="4.67576"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#6e081c"></stop>
                        <stop
                          offset="1"
                          stopColor="var(--icon-color-brand-secondary)"
                        ></stop>
                      </linearGradient>
                      <clipPath id="clip0_140_22052">
                        <rect width="24" height="24" fill="white"></rect>
                      </clipPath>
                    </defs>
                  </svg>
                </a>
              </div>
            )}
            {promotions?.Facebook && (
              <div className="flex items-center justify-center overflow-hidden rounded-md">
                <a
                  title={promotions?.Facebook?.url}
                  href={promotions?.Facebook?.url}
                  target="_blank"
                  className="flex  items-center justify-center rounded-md bg-bg_color_icon size-[45px] md:size-[50px] hover:scale-[110%] transition-all duration-300 hover:shadow-lg hover:opacity-90"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    className="w-6 h-6 md:w-[28px] md:h-[28px]"
                  >
                    <path
                      d="M24 12.0301C24 5.38948 18.624 0 12 0C5.376 0 0 5.38948 0 12.0301C0 17.8526 4.128 22.7008 9.6 23.8195V15.6391H7.2V12.0301H9.6V9.02256C9.6 6.70075 11.484 4.81203 13.8 4.81203H16.8V8.42105H14.4C13.74 8.42105 13.2 8.96241 13.2 9.62406V12.0301H16.8V15.6391H13.2V24C19.26 23.3985 24 18.2737 24 12.0301Z"
                      fill="url(#paint0_linear_140_22057)"
                    ></path>
                    <defs>
                      <linearGradient
                        id="paint0_linear_140_22057"
                        x1="-2.24"
                        y1="0"
                        x2="28.5351"
                        y2="2.61158"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stopColor="#6e081c"></stop>
                        <stop
                          offset="1"
                          stopColor="var(--icon-color-brand-secondary)"
                        ></stop>
                      </linearGradient>
                    </defs>
                  </svg>
                </a>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactUs;
